import { render, staticRenderFns } from "./ButtonFilter.vue?vue&type=template&id=3f2f44b7&scoped=true&"
import script from "./ButtonFilter.vue?vue&type=script&lang=js&"
export * from "./ButtonFilter.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFilter.vue?vue&type=style&index=0&id=3f2f44b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f44b7",
  null
  
)

export default component.exports